import { Paragraph } from "tiptap";

export default class TextParagraph extends Paragraph {
	get name() {
		return "paragraph";
	}

	get schema() {
		return {
			content: "text*"
		};
	}
}
